var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.75,
    height: 49,
    viewBox: "0 0 36.75 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M17.408,24.51c-.479-1.531-.469-4.488-.191-4.488C18.021,20.021,17.944,23.553,17.408,24.51Zm-.163,4.517a44.16,44.16,0,0,1-2.718,6,35.24,35.24,0,0,1,6.02-2.1A12.4,12.4,0,0,1,17.246,29.027ZM8.24,40.971c0,.077,1.263-.517,3.34-3.847C10.939,37.726,8.8,39.468,8.24,40.971ZM23.734,15.313H36.75V46.7a2.291,2.291,0,0,1-2.3,2.3H2.3A2.291,2.291,0,0,1,0,46.7V2.3A2.291,2.291,0,0,1,2.3,0H21.438V13.016A2.3,2.3,0,0,0,23.734,15.313Zm-.766,16.442a9.605,9.605,0,0,1-4.087-5.149c.431-1.771,1.11-4.46.593-6.144-.45-2.814-4.058-2.536-4.575-.651-.479,1.751-.038,4.221.775,7.369a89.867,89.867,0,0,1-3.9,8.211c-.01,0-.01.01-.019.01-2.594,1.33-7.044,4.259-5.216,6.508a2.974,2.974,0,0,0,2.058.957c1.713,0,3.417-1.723,5.847-5.914A54.552,54.552,0,0,1,22,34.731,14.5,14.5,0,0,0,28.127,36.6a2.477,2.477,0,0,0,1.885-4.154c-1.33-1.3-5.2-.928-7.044-.689ZM36.08,10.049,26.7.67A2.3,2.3,0,0,0,25.074,0H24.5V12.25H36.75v-.584A2.29,2.29,0,0,0,36.08,10.049ZM28.988,34.482c.392-.258-.239-1.139-4.1-.861C28.443,35.133,28.988,34.482,28.988,34.482Z",
    fill: "#ff4e61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.ce1229694039152b814f196b8630d625.svg";
export { ForwardRef as ReactComponent };